import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import VueAwesomeSwiper from "vue-awesome-swiper";
import {post, get, api_url} from './utils/http.js'
import {formatTime, formatSeconds, backTop, getContactTel} from "./utils/helper"
import 'vant/lib/index.css'
import 'swiper/dist/css/swiper.min.css'
import "./assets/css/base.css"
import "./assets/css/style.css"

Vue.config.productionTip = false
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$api = api_url()
Vue.prototype.formatTime = formatTime
Vue.prototype.$formatSeconds = formatSeconds
Vue.prototype.$backTop = backTop
Vue.prototype.$getContactTel = getContactTel
Vue.use(Vant)
Vue.use(VueAwesomeSwiper)
new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    timerId: ''
  },
  watch: {
    '$route': {
      handler () {
        // console.log('aaaaa')
        document.documentElement.scrollTop = this.$route.meta.y
      }
    }
  },
  mounted(){
    // console.log(this.justifyPos)
    window.addEventListener('scroll', this.justifyPos)
  },
  methods: {
    justifyPos () {
      if (this.timerId) clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        // console.log(window.pageYOffset)
        this.$route.meta.y = window.pageYOffset
      }, 30)
    }
  },
}).$mount('#app')
//npm run build
